"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _DonutChart = _interopRequireDefault(require("./DonutChart"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "countdown": "countdown_timer-module__countdown___D_wk3"
};
class CountdownTimer extends _react.default.PureComponent {
  static propTypes = {
    eventTime: T.number.isRequired,
    className: T.string,
    interval: T.number
  };
  static defaultProps = {
    interval: 1000
  };
  constructor(props) {
    super(props);
    this.state = {
      duration: this.getDuration()
    };
  }
  componentDidMount() {
    const {
      interval
    } = this.props;
    this._mounted = true;
    this.interval = (0, _setInterval2.default)(() => {
      if (this._mounted) this.setState({
        duration: this.getDuration()
      });
    }, interval);
  }
  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this.interval);
  }
  getDuration() {
    const {
      eventTime
    } = this.props;
    return _moment.default.duration(eventTime - new Date().getTime());
  }
  render() {
    const {
      className
    } = this.props;
    const {
      duration
    } = this.state;
    const showCircle = duration.asMinutes() <= 1;
    const secondsLeft = duration.seconds();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, showCircle && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.countdown, className)
    }, /*#__PURE__*/_react.default.createElement(_DonutChart.default, {
      numerator: secondsLeft < 0 ? 0 : secondsLeft,
      denominator: 60,
      width: 30,
      height: 30
    })), !showCircle && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "time.duration.subHour",
      values: {
        min: duration.minutes(),
        sec: duration.seconds()
      }
    }));
  }
}
exports.default = CountdownTimer;